import { Link } from '@mui/material';
import { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';

import { Alert } from '@vivaahealth/design-system';
import { useAuthContext } from 'common';

import { isValidRedirect, popLoginRedirect, setLoginEmail } from '../utils/login';

export function LoginSuccess() {
  const context = useAuthContext();
  const [redirectTo, setRedirectTo] = useState<{
    local?: string;
    remote?: string;
  } | null>(null);

  useEffect(() => {
    if (context.status !== 'resolved') return;

    if (!context.user?.registered) {
      setRedirectTo({ local: '/login' });
      return;
    }

    setLoginEmail(context.user.email);
    const storedRedirect = popLoginRedirect();
    if (storedRedirect && isValidRedirect(storedRedirect)) {
      setRedirectTo({ remote: storedRedirect });
    } else {
      setRedirectTo({ local: '/' });
    }
  }, [context]);

  if (!redirectTo) {
    return (
      <div className="h-100 d-flex align-items-center justify-content-center">
        Loading current user...
      </div>
    );
  } else if (redirectTo.remote && isValidRedirect(redirectTo.remote)) {
    // FIXME
    // eslint-disable-next-line react-hooks/immutability
    window.location.href = redirectTo.remote;
    return (
      <div className="h-100 d-flex align-items-center justify-content-center">
        <Alert title="Redirecting">
          <Link href={redirectTo.remote} rel="noreferrer noopener">
            {redirectTo.remote}
          </Link>
        </Alert>
      </div>
    );
  } else if (redirectTo.local) {
    return <Redirect to={redirectTo.local} />;
  } else {
    return <Redirect to="/" />;
  }
}
